import { ServiceData } from '@/types';

import audios from './MEDITATION_AUDIOS_FR.json';
import guides from './MEDITATION_GUIDES_FR.json';

export const MEDITATION_DATA_FR: ServiceData = {
  audios,
  guides,
};
